import { Autocomplete, Checkbox, Grid, Input, TextField } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import MDBox from 'components/MDBox';
import React, { useState, useEffect } from 'react';
import MDButton from 'components/MDButton';
import { getAllPlayers } from 'services/filters';
import { useSearchParams } from 'react-router-dom';
import LivePlayers from 'layouts/player-management/live-players/LivePlayers';
import MDTypography from 'components/MDTypography';

const icon = <CheckBoxOutlineBlankIcon fontSize='small' />;
const checkedIcon = <CheckBoxIcon fontSize='small' />;

const Filters = ({ filters, setFilters }) => {
  const [usernameOptions, setUsernameOptions] = useState([]);
  const [usernameInput, setUsernameInput] = useState('');
  const [isDemoChecked, setIsDemoChecked] = useState(false);
  const [isClaimedCodes, setIsClaimedCodes] = useState(false);
  const [playerUsernames, setPlayerUsernames] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();

  const [searchTerm, setSearchTerm] = useState(filters?.search); // Local state for debouncing

  useEffect(() => {
    const delay = setTimeout(() => {
      setFilters((prev) => ({
        ...prev,
        search: searchTerm
      }));
    }, 1000);

    return () => clearTimeout(delay);
  }, [searchTerm, setFilters]);

  // fetch options
  useEffect(() => {
    // fetch player usernames
    usernameOptions.forEach((username) => {
      if (filters?.users) {
        if (filters.users.includes(username.value)) {
          setPlayerUsernames((prev) => [...prev, username]);
        }
      }
    });
  }, []);

  useEffect(() => {
    if (!playerUsernames.length) {
      setFilters({
        users: [],
        isDemo: isDemoChecked,
        isPromoCodeUser: isClaimedCodes,
        search: filters?.search
      });
    }
  }, [playerUsernames]);

  const updateUsernames = (event, value) => {
    setPlayerUsernames(value);
  };
  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setIsDemoChecked(isChecked);
  };

  const handleCheckboxCodesChange = (event) => {
    const isChecked = event.target.checked;
    setIsClaimedCodes(isChecked);
  };

  const handleUsernameInput = (event) => {
    setUsernameInput(event.target.value);
    if (event.target.value.length > 2) {
      getAllPlayers(event.target.value, filters?.isDemo).then((players) => {
        // Ensure players is always an array
        setUsernameOptions(Array.isArray(players) ? players : []);
      }).catch((error) => {
        console.error('Error fetching players:', error);
        setUsernameOptions([]);
      });
    } else if (event.target.value.length < 2) {
      setUsernameOptions([]);
    }
  };

  const onSubmit = () => {
    setFilters({
      users: playerUsernames,
      isDemo: isDemoChecked,
      isPromoCodeUser: isClaimedCodes,
      search: filters?.search
    });
  };

  function checkActiveButton() {
    return (
      !playerUsernames.length &&
      ((filters?.isDemo == null && isDemoChecked === false) || isDemoChecked === filters?.isDemo) &&
      ((filters?.isPromoCodeUser == null && isClaimedCodes === false) || isClaimedCodes === filters?.isPromoCodeUser)
    );
  }
  return (
    <MDBox
      sx={{
        width: '100%',
        flexGrow: 1
      }}
    >
      <Grid container spacing={2} justifyContent={'space-between'} alignItems={'stretch'}>
        <Grid gap={10} container>
          <Input
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder='Nickname, email, first name...'
          ></Input>
          {/* <MDButton>Search</MDButton> */}
        </Grid>
        <Grid item xs={5} md={5}>
          <MDBox>
            {/* <MDTypography> */}
            <LivePlayers></LivePlayers>
            {/* </MDTypography> */}
          </MDBox>
          <MDBox>
            {/* <Autocomplete
              multiple
              limitTags={2}
              options={usernameOptions}
              disableCloseOnSelect
              value={playerUsernames}
              onChange={updateUsernames}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              getOptionLabel={(option) => option.label}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
                  {option.label}
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label='Player username or Wallet ID'
                  variant='standard'
                  value={usernameInput}
                  onChange={handleUsernameInput}
                />
              )}
            /> */}
          </MDBox>
        </Grid>
        <Grid item xs={5} md={4}>
          <MDBox
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-around'
            }}
          >
            <div>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                checked={isDemoChecked}
                onChange={(event) => handleCheckboxChange(event)}
              />
              <label
                style={{
                  fontSize: '14px',
                  color: '#adb3ba',
                  cursor: 'pointer'
                }}
              >
                Demo players
              </label>
            </div>

            {/* <div>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                checked={isClaimedCodes}
                onChange={(event) => handleCheckboxCodesChange(event)}
              />
              <label
                style={{
                  fontSize: "14px",
                  color: "#adb3ba",
                  cursor: "pointer",
                }}
              >
                Claimed codes
              </label>
            </div> */}
          </MDBox>
        </Grid>
        <Grid item xs={2} md={2}>
          <MDButton variant='text' disabled={checkActiveButton()} onClick={onSubmit}>
            Apply
          </MDButton>
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default Filters;
